<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title3"><h1 class="title">Preface</h1>
<p class="p"><span>While this latest history of the Highland Regiments cannot claim to be comprehensive, since each chapter could easily have been expanded into a book in itself, it will I hope provide for the first time a balanced account of how the regiments came to be raised, why they were to be different from ordinary regiments and why they came to represent not just the Highlands, but became synonymous with Scottish soldiers.</span></p>
<p class="p-indent"><span>It has been my pleasure in writing this book to address a number of the myths attaching to these Highland Warriors: not with any view to iconoclasm but rather to explaining what lay behind them, why those events occurred and, in the case of the Gordons’ celebrated ‘stirrup charge’ at Waterloo, to examining how it happened. Inevitably, in order to cover so much ground it has been necessary to focus on certain themes in each chapter; if some regiments and individuals receive more than their fair share of coverage then that is because their stories are important to understanding the whole.</span></p>
<p class="p-indent"><span>It is customary to unreservedly acknowledge the author’s ultimate culpability for any errors that pass undetected through the writing and editorial processes, and, rather more agreeably, to record the assistance of those who helped it to see the light of day at all: the first and foremost being Tim Newark, who had faith in it; Michael Leventhal, who listened to him; and Philip Haythornthwaite, who read it, made some constructive suggestions, and not only pronounced it fit to be read but was also prevailed upon to write a foreword.</span></p>
<p class="p-indent"><span>Otherwise the usual suspects who deserve to be mentioned include Dr John Houlding; David Ryan of Caliver Books; the staff of the National Archives at Kew; the libraries of the Scottish War Museum in Edinburgh Castle and the Literary and Philosophical Society of Newcastle upon Tyne.</span></p></a></div><a id="title3">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781783830893_fm02.vue?5fb449f4